import { isDate } from "util";
import { formatPercentage } from "./utils";

//this can be used to map filter methods as regular methods inside vue components (a bit like mapState and mapActions)
export function mapFilters(filters) {
    return filters.reduce((result, filter) => {
        result[filter] = function (...args) {
            return this.$options.filters[filter](...args);
        };
        return result;
    }, {});
}

export default function registerGlobalVueFilters(Vue) {

    Vue.filter('formatDate', function (value) {
        if (typeof value === 'undefined' || value === '') return '';
        try {
            if (!isDate(value)) {
                value = new Date(value);
            }
            return value.getDate() + '.' + (value.getMonth() + 1) + '.' + value.getFullYear();
        } catch {
            return 'invalid date';
        }
    });

    Vue.filter('formatPrice', function (value) {
        if (typeof value === 'undefined' || value === '') return '';
        var num = Number(value);
        if (isNaN(num)) return '';

        return num.toLocaleString('de-CH', { style: 'currency', currency: 'CHF' });
    });

    Vue.filter('formatAmount', function (value) {
        if (typeof value === 'undefined' || value === '') return '';
        var num = Number(value);
        if (isNaN(num)) return '';

        return num.toLocaleString('de-CH', { minimumIntegerDigits: 1 });
    });

    Vue.filter('formatPercent', function (value) {
        return formatPercentage(value);
    });
}